<template>
    <div class="progress special-negative-margins" style="height: 5px;">
        <div role="progressbar"
            :class="progressBarClass"
            :aria-valuenow="progressBarValue==100 ? 95 : progressBarValue"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="'width: ' + (progressBarValue==100 ? 95 : progressBarValue) + '%'"></div>
    </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useInjectedApplicationSettings } from '@/composables/useApplicationSettingsProvider.js';

const applicationSettings = useInjectedApplicationSettings();

const progressBarValue = computed(() => {
    return !!applicationSettings.progressBar.isFinalStep ?
        100 : applicationSettings.progressBar.valueNow;
});

const progressBarClass = computed(() => {
    let elementClass = '';
    elementClass += 'progress-bar progress-bar-striped progress-bar-animated ';
    return elementClass;
});

function increaseProgressBarValue() {
    const total = applicationSettings.progressBar.totalSteps;
    const step = applicationSettings.progressBar.step;

    if (total > 0) {
        const next = Math.min(Math.round((step / total) * 100), 95);
        if (next > applicationSettings.progressBar.valueNow) {
            applicationSettings.progressBar.valueNow = next;
        }
    }
}

watch(() => applicationSettings.progressBar.step, () => {
    increaseProgressBarValue();
});
</script>

<style scoped>

.special-negative-margins {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
    margin-top: -1.5rem !important;
}

@media (min-width: 768px) {
    .special-negative-margins {
        margin-left: -3rem !important;
        margin-right: -3rem !important;
    }
}
</style>
